import React from 'react';

const ExpiredInviteEnvelope = props => (
  <svg viewBox="0 0 470 436" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M459.809 142.293C477.141 286.274 474.091 331.081 431.23 355.093C388.37 379.104 290.764 473.525 190.689 418.947C90.6149 364.37 -15.0306 318.319 1.77326 198.947C18.5771 79.574 17.838 40.9146 116.319 28.8742C214.801 16.8384 262.778 -1.59194 311.179 0.11C321.357 0.466817 442.477 -1.68712 459.809 142.293Z"
      fill="#EAEFFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M128.588 137.52C128.739 137.35 128.9 137.19 129.061 137.03C133.581 132.52 139.708 130 146.106 130H322.892C329.291 130 335.418 132.52 339.938 137.03C340.149 137.23 340.35 137.44 340.54 137.64L239.782 219.061C236.829 221.441 232.61 221.441 229.657 219.061L128.588 137.52ZM346.98 153.05C346.99 153.37 347 153.68 347 154V282C347 288.36 344.459 294.47 339.939 298.97C335.419 303.47 329.291 306 322.893 306H146.107C139.709 306 133.581 303.47 129.061 298.97C124.541 294.47 122 288.36 122 282V154C122 153.61 122.01 153.21 122.03 152.82L219.544 231.489C228.393 238.629 241.07 238.629 249.91 231.479L346.98 153.05Z"
      fill="url(#paint0_linear_76_262)"
    />
    <g filter="url(#filter0_d_76_262)">
      <circle cx="316.5" cy="283.5" r="53.5" fill="white" />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M292.121 253.88C290.951 252.707 289.05 252.707 287.88 253.88C286.707 255.05 286.707 256.951 287.88 258.121L341.879 312.12C343.049 313.293 344.95 313.293 346.12 312.12C347.293 310.95 347.293 309.049 346.12 307.879L333.436 295.195L341.07 287.56C348.975 279.654 348.975 266.837 341.07 258.931C333.164 251.026 320.347 251.026 312.441 258.931L304.806 266.564L292.121 253.88ZM309.049 270.805L317 278.759L322.195 273.562C323.368 272.392 325.266 272.392 326.439 273.562C327.609 274.734 327.609 276.633 326.439 277.806L321.241 283L329.195 290.951L336.829 283.318C342.392 277.755 342.392 268.735 336.829 263.172C331.265 257.609 322.246 257.609 316.683 263.172L309.049 270.805Z"
      fill="#F16159"
    />
    <path
      d="M321.95 298.193L326.194 302.437L321.559 307.069C313.654 314.975 300.837 314.975 292.931 307.069C285.025 299.164 285.025 286.347 292.931 278.441L297.563 273.806L301.807 278.05L297.172 282.682C291.609 288.245 291.609 297.265 297.172 302.828C302.735 308.391 311.755 308.391 317.317 302.828L321.95 298.193Z"
      fill="#F16159"
    />
    <path
      d="M307.562 288.195L309.759 286.001L314 290.242L311.806 292.439C310.633 293.609 308.735 293.609 307.562 292.439C306.392 291.266 306.392 289.368 307.562 288.195Z"
      fill="#F16159"
    />
    <defs>
      <filter
        id="filter0_d_76_262"
        x="253"
        y="220"
        width="127"
        height="127"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_76_262"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_76_262"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_76_262"
        x1="253.295"
        y1="408.059"
        x2="435.046"
        y2="98.471"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#65E0FB" />
        <stop offset="0.296875" stopColor="#3A8CF7" />
        <stop offset="0.65625" stopColor="#285AFF" />
        <stop offset="0.973958" stopColor="#5FD3FB" />
      </linearGradient>
    </defs>
  </svg>
);

export default ExpiredInviteEnvelope;
